<template>
<div class="form">
  <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">JRE - SEKSYEN 2 : KESIHATAN</h1>

        <v-text-field
          outlined 
          dense
          rounded
          v-model="HID"
          label="HID"
          width="20px"
          disabled
        ></v-text-field>


      <!-- DATATABLE  -->
      <v-card  color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataJRE2"
              
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
              :footer-props="{'items-per-page-options':[3,15, 30, 50, 100, -1]}"
            >
            <!-- <template v-slot:[`item.SR`]="{ item }">
                    {{ paparSR(item.SR) }}
                  </template>  -->
            </v-data-table>
      </v-card>  
    </v-card> 


<v-card>
  <span style="color:red;font-weight:bold;font-size: small;"><v-col>Medan yang bertanda * wajib diisi </v-col ></span>
  <v-card-title>
   SEKSYEN 2 : KESIHATAN
   (Pilih satu jawapan sahaja)
  </v-card-title>
  <v-card-text>
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    > 
      <!-- S152 -->
      <v-row>
        <v-col class="black--text">
          S.1 Berapakah jarak dan anggaran masa perjalanan dari tempat kediaman ke institusi kesihatan yang terdekat? <br>
        </v-col >
      </v-row>
            <v-container>
             <v-row>
                 <v-col class="black--text">            
                  i. Institusi kesihatan kerajaan [KKK] 

                  <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>(Cth: Hospital Negeri, Hospital Daerah, Klinik Kesihatan, Klinik Desa atau Klinik Komuniti)</span>
          </v-tooltip>

                    <!-- </v-col >
                      </v-row>      -->
                        <v-row>
                           <v-col cols="4" sm="6" md="4" class="black--text">  
                             Jarak <strong> [KKKj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>

                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="KKK"
                                  :rules="[rules.KKKj]"
                                  ></v-autocomplete>
                                  </v-col>
                                    
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                              Masa <strong> [KKKm] </strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                  :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="KKKm"
                                  :rules="[rules.KKKm]"
                                  ></v-autocomplete>
                                 </v-col>
                          </v-row>        
                  </v-col > 
            </v-row>
  <!-- S152 -->
        <v-row>
           <v-col class="black--text">
          ii. Institusi kesihatan swasta [KKS]
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
            </template>
            <span>(Cth: Hospital Swasta, Pusat Kesihatan Swasta atau Klinik Swasta)</span>
          </v-tooltip>
                    <v-row>
                       <v-col cols="4" sm="6" md="4" class="black--text">  
                             Jarak <strong>[KKSj]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                  <v-autocomplete
                                  :items="Jarak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="KKS"
                                  :rules="[rules.KKSj]"
                                  ></v-autocomplete>
                              </v-col>
                              
                              <v-col cols="4" sm="6" md="4" class="black--text">
                              Masa <strong>[KKSm]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                <v-autocomplete
                                   :items="Masa"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  return-object
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="KKSm"
                                  :rules="[rules.KKSj]"
                                  ></v-autocomplete>
                                 </v-col>
                                 </v-row>
                                 </v-col >
                            </v-row>  
              </v-container>
      

     
    <!-- S153 -->
    <!-- //<v-form ref="form2" :disabled="disabledInput"> -->
    <v-form ref="form2">
      <v-row>
        <v-col class="black--text">
          S.2 Adakah perkhidmatan kesihatan bergerak terdapat di kawasan anda?<br>
        </v-col >
      </v-row>
       <v-container> 
              <v-row>
                  <v-col cols="4" sm="6" md="4" class="black--text">
                                  i. Perkhidmatan kesihatan kerajaan <strong>[PKK]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                      <v-autocomplete
                                         :items="yaTidak"
                                          :item-text="item => item.id +' - '+ item.desc"
                                          label=""
                                          return-object
                                          solo
                                          outlined
                                          dense
                                          style="width:350px;"
                                          v-model="PKK"
                                          :rules="[rules.PKK]"
                                        ></v-autocomplete>
                                    </v-col> 
                            
                                
                                <v-col cols="4" sm="6" md="4" class="black--text">
                                <!-- <v-col cols="4" sm="6" md="4" class="black--text" :disabled="disabledInput"> -->
                                  ii. Perkhidmatan kesihatan swasta <strong>[PKS]</strong><span style="color:red;font-weight:bold;font-size: small;"> * </span>
                                      <v-autocomplete
                                          :items="yaTidak"
                                          :item-text="item => item.id +' - '+ item.desc"
                                          label=""
                                          return-object
                                          solo
                                          outlined
                                          dense
                                          style="width:350px;"
                                          v-model="PKS"
                                          :rules="[rules.PKS]"
                                        ></v-autocomplete>
                                      </v-col>
                                        </v-row>                         
                                  </v-container>  
                                     
                                     
                                   

      <!-- S154 -->
      <v-col v-show="showS154" class="black--text">
          <v-row>
            <v-col class="black--text">
              S.3 Nyatakan jenis perkhidmatan di S.2 [jawapan berganda diterima; pilihan jawapan tidak boleh sama] <strong>[JPK]</strong><br>
            </v-col >
          </v-row>
                <v-container>
                 <v-row>
                    <v-col cols="4" sm="6" md="4" class="black--text">
                      i.
                      <v-autocomplete
                        :items="JenisPerkhidmatan"
                        :item-text="item => item.id +' - '+ item.desc"
                        label=""
                        return-object
                        required
                        solo
                        outlined
                        dense
                        style="width: 350px"
                        v-model="S154"
                        @change="S154_JPK1()"
                      ></v-autocomplete>           
                    </v-col>

                    <v-col cols="4" sm="6" md="4" class="black--text">
                      ii.
                      <v-autocomplete
                          :items="JenisPerkhidmatan"
                          :item-text="item => item.id +' - '+ item.desc"
                          label=""
                          return-object
                          required
                          solo
                          outlined
                          dense
                          style="width: 350px"
                          v-model="JPK2"
                          @change="S154_JPK2()"
                      ></v-autocomplete>           
                    </v-col>
                    <v-col cols="4" sm="6" md="4" class="black--text">
                      iii.
                      <v-autocomplete
                          :items="JenisPerkhidmatan"
                          :item-text="item => item.id +' - '+ item.desc"
                          label=""
                          return-object
                          required
                          solo
                          outlined
                          dense
                          style="width: 350px"
                          v-model="JPK3"
                          @change="S154_JPK3()"
                      ></v-autocomplete>           
                    </v-col>
                 </v-row>
               </v-container>

 <!-- S155 -->
      <v-row>
         <v-col class="black--text">
               S.4 Berapakah kekerapan perkhidmatan kesihatan bergerak sampai ke kawasan anda? <strong>[KP]</strong><br>
                  </v-col >
                    </v-row> 
                      <v-container> 
                                <v-autocomplete
                                  :items="Kerap"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="KP"
                                  ></v-autocomplete>
                            </v-container>           
  </v-col >
      <!-- S156 -->
      <v-row>
         <v-col class="black--text">
             S.5 Sejauh manakah kepuasan anda terhadap kualiti perkhidmatan kesihatan yang diberikan semasa mendapatkan rawatan di institusi kesihatan yang terdekat dalam tempoh 12 bulan yang lalu.<br>
                  </v-col >
                    </v-row> 
                      <v-container> 
                        <v-row>
                            <v-col class="black--text" cols="4" sm="4" md="4">  
                             i. Institusi kesihatan kerajaan <strong>[JKK]</strong>
                                  <v-autocomplete
                                  :items="Satisfaction"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"                              
                                  v-model="JKK"
                                  ></v-autocomplete>
                          </v-col>
                          
                          <v-col class="black--text" >
                              ii. Institusi kesihatan swasta <strong>[JKS]</strong>
                                <v-autocomplete
                                  :items="Satisfaction"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="JKS"
                                  ></v-autocomplete>
                          </v-col>
                        </v-row>
                    </v-container>
                    

                  <!--s157 (07/03/2024)-->
                  <v-row>
                    <v-col class="black--text">
                        S.6 Berapakah kos perkhidmatan di institusi kesihatan yang terdekat mampu untuk ditanggung? <br>
                    </v-col>
                  </v-row> 
                  <v-container>
                    <v-row>
                      <v-col class="black--text" cols="4" sm="4" md="4">  
                        i. Perkhidmatan institusi kesihatan kerajaan <strong>[KPKK]</strong>
                        <v-autocomplete
                          :items="cost"
                          :item-text="item => item.id +' - '+ item.desc"
                          label=""
                          return-object
                          solo
                          outlined
                          dense
                          style="width:350px;"                              
                          v-model="KPKK"
                        ></v-autocomplete>
                      </v-col>

                      <v-col v-show="showKPKKRM" cols="6" sm="6" md="4">  
                        <strong>[KPKKRM]</strong>
                        <v-text-field
                          v-model="KPKKRM"
                          persistent-hint
                          required   
                          solo               
                          outlined
                          dense
                          style="width: 350px"
                          type="number"
                          @keypress="limitDigits"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="black--text" cols="4" sm="4" md="4">  
                        ii. Perkhidmatan institusi kesihatan swasta <strong>[KPKS]</strong>
                        <v-autocomplete
                          :items="costswasta"
                          :item-text="item => item.id +' - '+ item.desc"
                          label=""
                          return-object
                          solo
                          outlined
                          dense
                          style="width:350px;"
                          v-model="KPKS"
                        ></v-autocomplete>
                      </v-col>

                      <v-col v-show="showKPKSRM" cols="6" sm="6" md="4">  
                        <strong>[KPKSRM]</strong>
                        <v-text-field
                          v-model="KPKSRM"
                          persistent-hint
                          required   
                          solo               
                          outlined
                          dense
                          style="width: 350px"
                          type="number"
                          @keypress="limitDigits"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>

  




                  <!---s158 07/03/2024-->
                  <v-row>
                    <v-col class="black--text">
                        S.7  Adakah kos pengangkutan ke institusi kesihatan mampu untuk ditanggung?  <br>
                    </v-col>
                  </v-row> 
                  <v-container> 
                      <v-row>
                          <v-col class="black--text" cols="4" sm="4" md="4">  
                              i. Institusi kesihatan kerajaan <strong>[PPKK]</strong>
                             
                              <v-autocomplete
                                  :items="yaTidak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"                              
                                  v-model="PPKK"
                              ></v-autocomplete>
                          </v-col>
                          
                          <v-col class="black--text">
                              ii. Institusi kesihatan swasta <strong>[PPKS]</strong>
                              
                              <v-autocomplete
                                  :items="yaTidak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="PPKS"
                              ></v-autocomplete>
                          </v-col>
                      </v-row>
                  </v-container>

                  <!---s158 07/03/2024-->
                  <!-- <v-row>
                    <v-col class="black--text">
                        S158. Adakah kos ubat-ubatan mampu untuk ditanggung? <br>
                    </v-col>
                  </v-row>  -->
                  <!-- <v-container> 
                      <v-row>
                          <v-col class="black--text" cols="4" sm="4" md="4">  
                              (i) Kos pembelian ubat-ubatan di kedai fizikal <strong>[PU]</strong>
                              <v-autocomplete
                                  :items="yaTidak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"                              
                                  v-model="PU"
                              ></v-autocomplete>
                          </v-col>
                          
                          <v-col class="black--text">
                              (ii) Kos pembelian ubat-ubatan di laman e-dagang <strong>[PUE]</strong>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-alert-circle
                                  </v-icon>
                                </template>
                                <span>(Cth: Shopee, Lazada, TiktokShop, dan lain-lain)</span>
                              </v-tooltip>
                              
                              <v-autocomplete
                                  :items="yaTidak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="PUE"
                              ></v-autocomplete>
                          </v-col>
                      </v-row>
                  </v-container> -->


                   <!---s159 07/03/2024-->
                   <!-- <v-row>
                    <v-col class="black--text">
                        S159.  Adakah kos peralatan perubatan mampu untuk ditanggung?  <br>
                    </v-col>
                  </v-row>  -->
                  <!-- <v-container> 
                      <v-row>
                          <v-col class="black--text" cols="4" sm="4" md="4">  
                              (i) Kos pembelian peralatan perubatan barang habis pakai <strong>[PPC]</strong>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-alert-circle
                                  </v-icon>
                                </template>
                                <span>(Cth: Test-kit, Test-stripe dan lain-lain )</span>
                              </v-tooltip>
                              <v-autocomplete
                                  :items="yaTidak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"                              
                                  v-model="PPC"
                              ></v-autocomplete>
                          </v-col>
                          
                          <v-col class="black--text">
                              (ii) Kos pembelian peralatan perubahan bukan barang habis pakai <strong>[PPNC]</strong>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    mdi-alert-circle
                                  </v-icon>
                                </template>
                                <span>(Cth: kerusi roda, tonglat, termometer, mesin pengukur tekanan darah dan lain-lain)</span>
                              </v-tooltip>
                              <v-autocomplete
                                  :items="yaTidak"
                                  :item-text="item => item.id +' - '+ item.desc"
                                  label=""
                                  return-object
                                  solo
                                  outlined
                                  dense
                                  style="width:350px;"
                                  v-model="PPNC"
                              ></v-autocomplete>
                          </v-col>
                      </v-row>
                  </v-container> -->


                    </v-form>
                </v-form>
              </v-card-text>

 
<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        :disabled="butangSimpan" 
    >
      Simpan
    </v-btn>

    <v-btn
      text
      color="primary"
      v-show="butangKemaskini"
      @click="kemaskiniJRE2()"
    >
      Kemaskini
    </v-btn>
     <!-- <v-btn
      text
      color="primary"
      @click="goTo()"
      >
      Seterusnya
    </v-btn> -->
</v-card-actions>
</v-card>

 <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert>
  
 
<!-- DIalog -->
<!-- <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{message}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
</v-dialog> -->

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
  
  <v-card-actions> 
        <v-spacer></v-spacer>
            <v-btn
                color="warning"
                @click='successDialog = false;'
            >
              Batal
            </v-btn>
            <v-btn
                color="pink"
                v-show="butangKemaskini"
                @click='successDialog = false;'
            >
              Kemaskini
            </v-btn>
            <v-btn
              color="primary"
              @click='goTo("2")'
            >
              Pengisian Seterusnya
            </v-btn>
      </v-card-actions>
    </v-card>
</v-dialog>

</div>
</template>
<script>
import axios from '../../plugins/axios'
//////////////////////////import services///////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage(); 

import schemeRule from '../../utils/scheme'

import hidServices from "@/services/lookupField";
const lookup = new hidServices();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
//////////////////////////end import services//////////////

export default {
    
    async beforeMount(){
        
        var dataHID = localStorageData.getHIDdata()

       this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;
        this.Tahun = dataHID.TAHUN;

        this.yaTidak = lookupFieldServices.getYaTidak();
        this.Jarak = lookupFieldServices.getJarak();
        this.Masa = lookupFieldServices.getMasa();
        this.Satisfaction = lookupFieldServices.getSatisfaction();
        this.cost = lookupFieldServices.getCost();
        this.costswasta = lookupFieldServices.getCostSwasta();
        this.Kerap = lookupFieldServices.getKerap();
        this.JenisPerkhidmatan = lookupFieldServices.getJenisPerkhidmatan();
        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;
        
        this.getData();//dapatkan data based on HID
       
    },
    // computed: {
    //    tambahlookuphargasebenar() {
    //   return lookup.getJarak();
    // },
    
        
    data: () => ({
        updateButton: true,
        saveButton: false,
        disabledInput: true,
        butangSimpan: true,
        butangSeterusnya: false,
        butangKemaskini: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage: "",
        errMessage: "",
        message: "Saving Data",
        popUpALert:false,
        search: "",
        yaTidak:[],
        /////////////////////data declaration//////////////////////////
        HID: "",
        PPB:[],
        KPB:[],
        S154:[],
        JPK2:[],
        JPK3:[],
        PKK: [],
        PKS:[],
        KKK:[],
        KKKm :[],
        KKS:[],
        KKSm:[],
        KP:[],
        JKK:[],
        JKS:[],
        KPKK: [],
        KPKKRM: [],
        KPKS: [],
        KPKSRM: [],
        PPKK:[],
        PPKS:[],
        // PU:[],
        // PUE:[],
        // PPC:[],
        // PPNC:[],
        dataJRE2:[],

        rules: {
          required: (v) => !!v || "field is required",
          KKKj: (v) => !!v || "Anggaran jarak perjalanan Klinik Kesihatan Kerajaan adalah diperlukan",
          KKKm: (v) => !!v || "Anggaran masa perjalanan Klinik Kesihatan Kerajaan adalah diperlukan",
          KKSj: (v) => !!v || "Anggaran jarak perjalanan Klinik Kesihatan Swasta adalah diperlukan",
          KKSm: (v) => !!v || "Anggaran masa perjalanan Klinik Kesihatan Swasta adalah diperlukan",
          PKK: (v) => !!v || "Perkhidmatan Kesihatan Kerajaan Bergerak adalah diperlukan",
          PKS: (v) => !!v || "Perkhidmatan Kesihatan Swasta Bergerak adalah diperlukan",
         
        },

        headers: [
          {
            align: 'start',
            sortable: false,
          },
              { text:'HID', value: 'HID'},
              { text:'KKK',value:'KKK'},
              { text:'KKKm',value:'KKKm'},
              { text:'KKS',value:'KKS'},
              { text:'KKSm',value:'KKSm'},
              { text:'PKK',value:'PKK'},
              { text:'PKS',value:'PKS'},
              { text:'JPK1',value:'JPK1'},
              { text:'JPK2',value:'JPK2'},
              { text:'JPK3',value:'JPK3'},
              { text:'KP',value:'KP'},            
              { text:'JKK',value:'JKK'},
              { text:'JKS',value:'JKS'},
              { text:'KPKK',value:'KPKK'},
              { text:'KPKKRM',value:'KPKKRM'},
              { text:'KPKS',value:'KPKS'},
              { text:'KPKSRM',value:'KPKSRM'},
              { text:'PPKK',value:'PPKK'},
              { text:'PPKS',value:'PPKS'},
              // { text:'PU',value:'PU'},
              // { text:'PUE',value:'PUE'},
              // { text:'PPC',value:'PPC'},
              // { text:'PPNC',value:'PPNC'},

          
        ],
       ///////////link untuk ke page/////////////////////
      breadcrumbs: [
       {
          text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
        {
          text: 'JRE',
          disabled: true,
          href: "JRE2",
        },
        
      ],
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      checkbox: false,
    }),
    methods: {
    //   paparSR(id) {
    //   let SR = "";
    //   lookup.getJarak().forEach(async function (element) {
    //     if (id === element.id) {
    //       SR = element.desc;
    //     }
    //   });
    //   return SR;
    // },
    

      S154_JPK1(){
          if(this.S154.id !=0 && this.S154.id == this.JPK2.id || this.S154.id == this.JPK3.id){
           this.S154 = { id: 0 };
          }
          if(this.S154.id==0){
          this.S154 = {"id":"0","disabled":true};}
      },
      S154_JPK2(){
            if(this.JPK2.id!=0 && this.JPK2.id == this.S154.id || this.JPK3.id == this.JPK2.id){
            this.JPK2 = { id: 0 };
            }
            if(this.JPK2.id==0 && this.JPK2.id == this.S154.id || this.JPK3.id == this.JPK2.id){
            this.JPK2 = this.JenisPerkhidmatan[3];
            }
      },
      S154_JPK3(){
            if(this.JPK3.id!=0 && this.JPK3.id == this.S154.id || this.JPK2.id == this.JPK3.id){
            this.JPK3 = { id: 0};
            }
            if(this.JPK3.id==0 && this.JPK2.id == this.S154.id || this.JPK3.id == this.JPK2.id){
            this.JPK3= this.JenisPerkhidmatan[3];
            }
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 7) {
            event.preventDefault();
        }
      },
      validate () {
        this.$refs.form.validate()
      },
      reset() {
        this.$refs.form.reset();
        this.$refs.form2.reset();
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      async simpan(){
        
        if (this.$refs.form.validate()){
            this.dialog =  true;
            setTimeout(() => (this.dialog = false), 2000)
         
            try {

                //const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/HK1`, {
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JREDua/JREDua`, {
                HID: this.HID,
                KKK: this.KKK.id,
                KKKm: this.KKKm.id,
                KKS: this.KKS.id,
                KKSm: this.KKSm.id,
                PKK: this.PKK.id,
                PKS: this.PKS.id,
                JPK1: this.S154.id,
                JPK2: this.JPK2.id,
                JPK3: this.JPK3.id,
                KP: this.KP.id,
                JKK: this.JKK.id,
                JKS: this.JKS.id,
                KPKK: this.KPKK.id,
                KPKKRM: this.KPKKRM,
                KPKS: this.KPKS.id,
                KPKSRM: this.KPKSRM,
                PPKK: this.PPKK.id,
                PPKS: this.PPKS.id,
                // PU: this.PU.id,
                // PUE: this.PUE.id,
                // PPC: this.PPC.id,
                // PPNC: this.PPNC.id,

                          
              })
                this.res = res.data
                this.successMessage = 'Data Disimpan!';
                this.getData();
                this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                this.reset();
                window.scrollTo(0, 0);
                //setTimeout(() => (this.goTo()), 1000);
                
            } catch (error) {
              console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
        }else{
          window.scrollTo(0, 0);
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'Please fill in the field!';
        }
      },
    
       async kemaskiniJRE2() {
         //alert(this.S154.id)
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/JREDua/kemaskiniJRE2`,
          {
                  HID: this.HID,
                  KKK: this.KKK.id,
                  KKKm: this.KKKm.id,
                  KKS: this.KKS.id,
                  KKSm: this.KKSm.id,
                  PKK: this.PKK.id,
                  PKS: this.PKS.id,
                  JPK1: this.S154.id,
                  JPK2: this.JPK2.id,
                  JPK3: this.JPK3.id,
                  KP: this.KP.id,
                  JKK: this.JKK.id,
                  JKS: this.JKS.id,
                  KPKK: this.KPKK.id,
                  KPKKRM: this.KPKKRM,
                  KPKS: this.KPKS.id,
                  KPKSRM: this.KPKSRM,
                  PPKK: this.PPKK.id,
                  PPKS: this.PPKS.id,
                  // PU: this.PU.id,
                  // PUE: this.PUE.id,
                  // PPC: this.PPC.id,
                  // PPNC: this.PPNC.id,
          })
                this.res = res.data;
                this.reset();
                this.butangKemaskini = false;
                this.successDialog = true;
                // setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Berjaya Dikemaskini!';
                this.getData();
                window.scrollTo(0, 0);
                //setTimeout(() => (this.goTo()), 1000);
                
                
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
            }
      
    },


      async padam(val){
        if(val == 0){
          this.popUpALert = true; 
        }
        else if(val == 1){
          
          try {
              ///////////tunjukkan alert padam////////////
              this.popUpALert = false;
                ////send delete to API///////
              if (this.$refs.form.validate()){
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JRF3/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Deleted!'
                this.saveButton = false;
                this.updateButton = true;
                this.reset();
                this.getData(); 
              }else{
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = "Please Fill In the field"
              }
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
        }
        else if(val == 2){
          this.popUpALert = false;
        }
          
      },
    
      async getData() {
      //dapatkan data dari table JRH based on HID
      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_URL}/JREDua/JREDua?HID=` +
            this.HID +
            `&NOAIR=` +
            this.NOAIR,
          {}
        );
        var dataz = res.data.data;
        this.dataJRE2 = dataz;
      } catch (error) {
        //console.log(error)
        this.errorDialog = true;
        setTimeout(() => (this.errorDialog = false), 2000);
        this.errMessage = "getData : " + error;
      }
    },

      handleClick(row) {
          this.kemaskiniDialog = true;
          this.successDialog = true;
          this.successMessage = 'Sila mulakan pengemaskinian!';
          // setTimeout(() => (this.kemaskiniDialog = false), 1000);

          this.butangSimpan = false;
          this.butangKemaskini = true;
          

          
          // this.KKK = row.KKK;
          // this.KKKm = row.KKKm;
          // this.KKS = row.KKS;
          // this.KKSm = row.KKSm;
          // this.PKK = row.PKK;
          // this.PKS = row.PKS;
          // this.S154 = row.S154;
          // this.JPK2 = row.JPK2;
          // this.KP = row.KP;
          // this.JKK = row.JKK;
          // this.JKS = row.JKS;
      
           if(row.KKK == 1){
            this.KKK = this.Jarak[0];
          }
          if(row.KKK == 2){
            this.KKK = this.Jarak[1];
          }
          if(row.KKK == 3){
            this.KKK = this.Jarak[2];
          }
           if(row.KKKm == 1){
            this.KKKm = this.Masa[0];
          }
          if(row.KKKm == 2){
            this.KKKm = this.Masa[1];
          }
          if(row.KKKm == 3){
            this.KKKm = this.Masa[2];
          }
          //-------------------------------
           if(row.KKS == 1){
            this.KKS = this.Jarak[0];
          }
          if(row.KKS == 2){
            this.KKS = this.Jarak[1];
          }
          if(row.KKS == 3){
            this.KKS = this.Jarak[2];
          }
           if(row.KKSm == 1){
            this.KKSm = this.Masa[0];
          }
          if(row.KKSm == 2){
            this.KKSm = this.Masa[1];
          }
          if(row.KKSm == 3){
            this.KKSm = this.Masa[2];
          }
           //----------------------------------------
          //   if(row.PKK == 1){
          //   this.PKK = this.yaTidak[0];
          // }
          // if(row.PKK == 2){
          //   this.PKK = this.yaTidak[1];
          // }
          //-------------------------------
          
          //  if(row.PKS == 1){
          //   this.PKS = this.yaTidak[0];
          // }
          // if(row.PKS == 2){
          //   this.PKS = this.yaTidak[1];
          // }
          // //-------------------------------
          //  if(row.S154 == 1){
          //   this.S154 = this.JenisPerkhidmatan[0];
          // }
          // if(row.S154 == 2){
          //   this.S154 = this.JenisPerkhidmatan[1];
          // }
          // if(row.S154 == 3){
          //   this.S154 = this.JenisPerkhidmatan[2];
          // }
          // if(row.S154 == 4){
          //   this.S154 = this.JenisPerkhidmatan[3];
          // }
         //----------------------------------------

          // if(row.JPK2 == 1){
          //   this.JPK2 = this.JenisPerkhidmatan[0];
          // }
          // if(row.JPK2 == 2){
          //   this.JPK2 = this.JenisPerkhidmatan[1];
          // }
          // if(row.JPK2 == 3){
          //   this.JPK2 = this.JenisPerkhidmatan[2];
          // }
          // if(row.JPK2 == 4){
          //   this.JPK2 = this.JenisPerkhidmatan[3];
          // }
         //-------------------------------------
          if(row.PKK == 1){
            this.PKK = this.yaTidak[0];
         
              if(row.JPK1 == 1){
                this.S154 = this.JenisPerkhidmatan[0];
                console.log(this.S154)
              }
              if(row.JPK1 == 2){
                this.S154 = this.JenisPerkhidmatan[1];
                console.log(this.S154)
              }
              if(row.JPK1 == 3){
                this.S154 = this.JenisPerkhidmatan[2];
                console.log(this.S154)
              }
              if(row.JPK1 == 4){
                this.S154 = this.JenisPerkhidmatan[3];
                console.log(this.S154)
              }

              if(row.JPK2 == 1){
                this.JPK2 = this.JenisPerkhidmatan[0];
              }
              if(row.JPK2 == 2){
                this.JPK2 = this.JenisPerkhidmatan[1];
              }
              if(row.JPK2 == 3){
                this.JPK2 = this.JenisPerkhidmatan[2];
              }
              if(row.JPK2 == 0){
                this.JPK2 = this.JenisPerkhidmatan[3];
              }

              if(row.JPK3 == 1){
                this.JPK3 = this.JenisPerkhidmatan[0];
              }
              if(row.JPK3 == 2){
                this.JPK3 = this.JenisPerkhidmatan[1];
              }
              if(row.JPK3 == 3){
                this.JPK3 = this.JenisPerkhidmatan[2];
              }
              if(row.JPK3 == 0){
                this.JPK3 = this.JenisPerkhidmatan[3];
              }}
           if(row.PKK == 2){
            this.PKK = this.yaTidak[1];
          }
        
          //-------------------------------
          
          if(row.PKS == 1){
            this.PKS = this.yaTidak[0];

              if(row.JPK1 == 1){
                this.S154 = this.JenisPerkhidmatan[0];
                console.log(this.S154)
              }
              if(row.JPK1 == 2){
                this.S154 = this.JenisPerkhidmatan[1];
                console.log(this.S154)
              }
              if(row.JPK1 == 3){
                this.S154 = this.JenisPerkhidmatan[2];
                console.log(this.S154)
              }
              if(row.JPK1 == 4){
                this.S154 = this.JenisPerkhidmatan[3];
                console.log(this.S154)
              }

              if(row.JPK2 == 1){
                this.JPK2 = this.JenisPerkhidmatan[0];
              }
              if(row.JPK2 == 2){
                this.JPK2 = this.JenisPerkhidmatan[1];
              }
              if(row.JPK2 == 3){
                this.JPK2 = this.JenisPerkhidmatan[2];
              }
              if(row.JPK2 == 0){
                this.JPK2 = this.JenisPerkhidmatan[3];
              }

              if(row.JPK3 == 1){
                this.JPK3 = this.JenisPerkhidmatan[0];
              }
              if(row.JPK3 == 2){
                this.JPK3 = this.JenisPerkhidmatan[1];
              }
              if(row.JPK3 == 3){
                this.JPK3 = this.JenisPerkhidmatan[2];
              }
              if(row.JPK3 == 0){
                this.JPK3 = this.JenisPerkhidmatan[3];
              }
          }
          if(row.PKS == 2){
            this.PKS = this.yaTidak[1];
          }

          if(row.KP == 1){
            this.KP = this.Kerap[0];
          }
          if(row.KP == 2){
            this.KP = this.Kerap[1];
          }
          if(row.KP == 3){
            this.KP = this.Kerap[2];
          }
          if(row.KP == 4){
            this.KP = this.Kerap[3];
          }
         //-------------------------------------

          if(row.JKK == 1){
            this.JKK = this.Satisfaction[0];
          }
          if(row.JKK == 2){
            this.JKK = this.Satisfaction[1];
          }
          if(row.JKK == 3){
            this.JKK = this.Satisfaction[2];
          }
           if(row.JKK == 4){
            this.JKK = this.Satisfaction[3];
          }
          if(row.JKK == 5){
            this.JKK = this.Satisfaction[4];
          }
          if(row.JKK == 6){
            this.JKK = this.Satisfaction[5];
          }
          //-------------------------------
         
          if(row.JKS == 1){
            this.JKS = this.Satisfaction[0];
          }
          if(row.JKS == 2){
            this.JKS = this.Satisfaction[1];
          }
          if(row.JKS == 3){
            this.JKS = this.Satisfaction[2];
          }
           if(row.JKS == 4){
            this.JKS = this.Satisfaction[3];
          }
          if(row.JKS == 5){
            this.JKS = this.Satisfaction[4];
          }
          if(row.JKS == 6){
            this.JKS = this.Satisfaction[5];
          }
          //-------------------------------

          if(row.KPKK == 1){
            this.KPKK =  this.cost[0];
          }
          if(row.KPKK == 2 ){
            this.KPKK =  this.cost[1];
          }
          if(row.KPKK == 3 ){
            this.KPKK =  this.cost[2];
            this.$nextTick(() => {
              this.KPKKRM = row.KPKKRM;
            });
           
          }

          //-------------------------------

          if(row.KPKS == 1){
            this.KPKS =  this.costswasta[0];
          }
          if(row.KPKS == 2 ){
            this.KPKS =  this.costswasta[1];
          }
          if(row.KPKS == 3 ){
            this.KPKS =  this.costswasta[2];
            this.$nextTick(() => {
              this.KPKSRM = row.KPKSRM;
            });
            
          }

          //-------------------------------
          if(row.PPKK == 1){
            this.PPKK=  this.yaTidak[0];
          }
          if(row.PPKK == 2 ){
            this.PPKK =  this.yaTidak[1];
          }

          //-------------------------------
          if(row.PPKS == 1){
            this.PPKS=  this.yaTidak[0];
          }
          if(row.PPKS == 2 ){
            this.PPKS =  this.yaTidak[1];
          }

          //-------------------------------
          // if(row.PU == 1){
          //   this.PU=  this.yaTidak[0];
          // }
          // if(row.PU == 2 ){
          //   this.PU =  this.yaTidak[1];
          // }
          //-------------------------------
          // if(row.PUE == 1){
          //   this.PUE=  this.yaTidak[0];
          // }
          // if(row.PUE == 2 ){
          //   this.PUE =  this.yaTidak[1];
          // }

          //-------------------------------
          // if(row.PPC == 1){
          //   this.PPC =  this.yaTidak[0];
          // }
          // if(row.PPC == 2 ){
          //   this.PPC =  this.yaTidak[1];
          // }

          //-------------------------------
          // if(row.PPNC == 1){
          //   this.PPNC =  this.yaTidak[0];
          // }
          // if(row.PPNC == 2 ){
          //   this.PPNC =  this.yaTidak[1];
          // }
          
       


      },
   
       goTo(option){

        if(option == "1"){
        this.$router.push({name: "ringkasanMaklumatIR"});
      } 
         if(option == "2"){
        this.$router.push({ name: "JRF3" });
    
        }
        //this.$router.push({name: "hk2", params: { data: this.data }});
      }
    },
    watch:{
      PKK(val){
          if(val.id == 2 && this.PKS.id == 2){
            this.JPK2 = { id: 0 };
            this.S154 = { id: 0 };
            this.KP = { id: 0 };
            this.showS154 = false;
            if(val.id == 1 && this.PKS.id ==2){
              this.showS154 = true;
            }
          }else{
            this.showS154 = true;
          }
        },
       PKS(val){
          if(val.id == 2 && this.PKK.id == 2){
            this.JPK2 = { id: 0 };
            this.S154 = { id: 0 };
            this.JPK3 = { id: 0 };
            this.KP = { id: 0 };
            this.showS154 = false;
             if(val.id == 1 && this.PKK.id ==2){
              this.showS154 = true;
           }
           }else{
           this.showS154 = true;
          }
        },
        KPKK(val) {
            if (val.id == 3) {
                
                this.showKPKKRM= true; // Show KPKKRM field
            } else {
                
                this.showKPKKRM= false; // Hide KPKKRM field
                this.KPKKRM = 0;
            }
        },

        KPKS(val) {
            if (val.id == 3) {
                
                this.showKPKSRM= true; // Show KPKKRM field
            } else {
               
                this.showKPKSRM= false; // Hide KPKKRM field
                this.KPKSRM =0;
                
            }
        },
        
        KP(val){
           if(this.PKS > 0){
             if(this.PKK > 0){
               if(this.KKSm > 0){
                 if(this.KKSj > 0){
                   if(this.KKKm > 0){
                     if(this.KKKj > 0){
                        this.butangSimpan = true;
                     }
                   }
                 }
               }
             }
            }else{
                  this.butangSimpan = false;
            }      
          },
      
      dataJRE2(){
      if(this.dataJRE2.length > 0) 
      {
        this.butangSimpan = false;
      }
    },
  

computed:{
  // S154(val){

  //       if(val.id == this.JPK2.id){
       
  //         this.S154 = '';
  //       }
  //     },
  //     JPK2(val){

  //         if(val.id == this.S154.id){
          
  //         this.JPK2 = '';
  //         }
  //       },
        }
    }
  }
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>
